/* eslint-disable eqeqeq */
import React, { useState, Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import { Grid, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(() => ({
  resize: {
    padding: 14,
  },
  label: {
    marginTop: 9,
    fontSize: 16,
    color: "#1558a2",
    fontWeight: 700,
    marginRight: 10,
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "right",
  },
}));

const ChangeStatusDispute = (props) => {
  const { handleClose, open, state, onSaveClick } = props;
  const classes = useStyles();
  const [disputedItemRemarks, setDisputedItemRemarks] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [voucherAmountType, setVoucherAmountType] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [voucherPercentage, setVoucherPercentage] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [voucherAmount, setVoucherAmount] = useState("");

  const onHandleChange = (event) => {
    const value = event.target.value;
    if (event.target.name == "disputedItemRemarks") {
      setDisputedItemRemarks(value);
    } else if (event.target.name == "voucherAmountType") {
      setVoucherAmountType(value);
    } else if (event.target.name == "voucherPercentage") {
      setVoucherPercentage(value);
    } else if (event.target.name == "voucherAmount") {
      setVoucherAmount(value);
    }
    // }else if(event.target.name=="effectiveVoucherFrom"){
    //     setEffectiveVoucherFrom(value)
    // }else if(event.target.name=="effectiveVoucherTo"){
    //     setEffectiveVoucherTo(value)
    // }
  };

  useEffect(() => {
    if (!open) {
      setDisputedItemRemarks("");
      setVoucherAmountType("");
      setVoucherPercentage("");
      setVoucherAmount("");
      // setEffectiveVoucherFrom("");
      // setEffectiveVoucherTo("");
    }
  }, [open]);

  return (
    <Fragment>
      <ControlledDialog
        hideClose
        open={open}
        disableBackdropClick
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >{`Order# ${state.selectedOrder.orderId} `}</span>
          </Fragment>
        }
        content={
          <Fragment>
            {state.actionTypeDisputedId == 100 ? (
              <>
                <div>
                  <Grid xs={12}>
                    <TextField
                      id="voucher-usage-limit"
                      variant="outlined"
                      value={disputedItemRemarks}
                      label={"Remarks"}
                      multiline
                      rows={4}
                      name={"disputedItemRemarks"}
                      fullWidth
                      onChange={(e) => onHandleChange(e)}
                    />
                  </Grid>
                </div>
                <div className={classes.actions}>
                  {/* <Button onClick={() => onSaveClick(state.actionTypeDisputedId,state.orderItemId,disputedItemRemarks,voucherAmountType,voucherPercentage,voucherAmount)} disabled={state.onCancelItemStatusLoading}  variant="contained" color="primary" >
                                        {state.onCancelItemStatusLoading ? <CircularProgress size={30} /> : 'Save'}
                                    </Button> */}
                  <Button
                    onClick={() =>
                      onSaveClick(
                        state.actionTypeDisputedId,
                        state.orderItemId,
                        disputedItemRemarks
                      )
                    }
                    disabled={state.onCancelItemStatusLoading}
                    variant="contained"
                    color="primary"
                  >
                    {state.onCancelItemStatusLoading ? (
                      <CircularProgress size={30} />
                    ) : (
                      "Save"
                    )}
                  </Button>
                  <Button
                    disabled={state.onCancelItemStatusLoading}
                    style={{ marginLeft: 20 }}
                    onClick={() => handleClose()}
                    variant="contained"
                  >
                    Cancel
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div>
                  <span
                    style={{
                      fontSize: 18,
                      color: "#1558a2",
                      fontWeight: 700,
                    }}
                  >
                    {state.actionTypeDisputedId == 10
                      ? "Are you sure, you want to Accept?"
                      : "Are you sure, you want to Reject ?"}
                  </span>
                </div>
                <br />
                <div>
                  <Grid xs={12}>
                    <TextField
                      id="voucher-usage-limit"
                      variant="outlined"
                      //    style={{width: "245px"}}
                      value={disputedItemRemarks}
                      label={"Remarks"}
                      multiline
                      rows={4}
                      name={"disputedItemRemarks"}
                      fullWidth
                      onChange={(e) => onHandleChange(e)}
                    />
                  </Grid>
                </div>
                <div className={classes.actions}>
                  <Button
                    onClick={() =>
                      onSaveClick(
                        state.actionTypeDisputedId,
                        state.orderItemId,
                        disputedItemRemarks
                      )
                    }
                    disabled={state.onCancelItemStatusLoading}
                    variant="contained"
                    color="primary"
                  >
                    {state.onCancelItemStatusLoading ? (
                      <CircularProgress size={30} />
                    ) : (
                      "Yes"
                    )}
                  </Button>
                  {/* <Button onClick={() => onSaveClick(state.actionTypeDisputedId,state.orderItemId,disputedItemRemarks,voucherAmountType,voucherPercentage,voucherAmount)} disabled={state.onCancelItemStatusLoading}  variant="contained" color="primary" >
                                        {state.onCancelItemStatusLoading ? <CircularProgress size={30} /> : 'Yes'}
                                    </Button> */}
                  <Button
                    disabled={state.onCancelItemStatusLoading}
                    style={{ marginLeft: 20 }}
                    onClick={() => handleClose()}
                    variant="contained"
                  >
                    No
                  </Button>
                </div>
              </>
            )}
          </Fragment>
        }
      />
    </Fragment>
  );
};

ChangeStatusDispute.propTypes = {
  handleClose: PropTypes.func,
  onSaveClick: PropTypes.func,
  onHandleChange: PropTypes.func,
  open: PropTypes.bool,
  state: PropTypes.object,
};

ChangeStatusDispute.defaultProps = {
  handleClose: (fn) => fn,
  onSaveClick: (fn) => fn,
  onHandleChange: (fn) => fn,
  open: false,
  state: {},
};

export default ChangeStatusDispute;
